import axios from "axios";
import { SELLER_DESHBOARD } from "../../constant/API constant";

export const Sellerdeshboard = () => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(`${process.env.REACT_APP_API_URL}${SELLER_DESHBOARD}`, {
    method: "GET",
    headers: { Authorization: jwt_token },
  });
};
